import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getAllDocumentType from '../../services/documentType/getAllDocumentType'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchDocumentType () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const documentTypes = yield call(getAllDocumentType, auth.token)
    yield put(fetchCombosSuccess({ documentTypes }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }

    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchDocumentType () {
  yield takeLatest(combosActionTypes.FETCH_DOCUMENT_TYPE, fetchDocumentType)
}
